module.exports = __webpack_public_path__ + "3a2870c65f48d47474b22ee46247114b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/images/bandeau.jpg
// module id = 32
// module chunks = 0